import { gql } from '@apollo/client'

/** Whether the radar is sweeping right now: one small read of the account's status. */
export const RADAR_SWEEP_STATUS = gql`
  query RadarSweepStatus {
    getAutoschedulerPostingStatus {
      accountId
      discoveryStatus
      discoveryStage
      lastRunAt
    }
  }
`
